import { createSlice } from "@reduxjs/toolkit";
import { fetchRemoteConfigThunk } from "./remoteConfiguration.actions";

export type TRemoteConfig = {
  FF_LIVE_CHAT: boolean;
  USD_GBP_EXCHANGE_RATE: number;
  GBP_USD_EXCHANGE_RATE: number;
  FF_TURNSTILE_WEB_ENABLED: boolean;
  FF_PLAID_BANK_ACCOUNT_CONNECTION: boolean;
  FF_EIS_FUND_V2: boolean;
  FF_FUND_TENORS_EXPLAINER: boolean;
  FF_NEW_DEAL_CARD: boolean;
  FF_ENTITY_TAX_RESIDENCIES: boolean;
  FF_PORTFOLIO_STATEMENT_BY_DATE: boolean;
  FF_DEAL_DETAILS_V3: boolean;
  FF_ISA_REALLOCATIONS: boolean;
  FF_HOMEPAGE: boolean;
  FF_APP_V3: boolean;
  FF_DEAL_ANCHORED_ONBOARDING: boolean;
  FF_UPCOMING_EARNINGS: boolean;
  FF_DEFAULT_BANK_ACCOUNTS: boolean;
};

export type TRemoteConfigState = {
  loading: boolean;
  neverLoaded: boolean;
  data: TRemoteConfig;
};

export const DEFAULT_REMOTE_CONFIG_PARAMETERS = {
  FF_LIVE_CHAT: false,
  USD_GBP_EXCHANGE_RATE: 0.796,
  GBP_USD_EXCHANGE_RATE: 1.36,
  FF_TURNSTILE_WEB_ENABLED: false,
  FF_PLAID_BANK_ACCOUNT_CONNECTION: false,
  FF_EIS_FUND_V2: false,
  FF_FUND_TENORS_EXPLAINER: false,
  FF_NEW_DEAL_CARD: false,
  FF_ENTITY_TAX_RESIDENCIES: false,
  FF_PORTFOLIO_STATEMENT_BY_DATE: false,
  FF_DEAL_DETAILS_V3: false,
  FF_ISA_REALLOCATIONS: false,
  FF_HOMEPAGE: false,
  FF_APP_V3: false,
  FF_DEAL_ANCHORED_ONBOARDING: false,
  FF_UPCOMING_EARNINGS: false,
  FF_DEFAULT_BANK_ACCOUNTS: false,
};

const INITIAL_STATE: TRemoteConfigState = {
  loading: false,
  neverLoaded: true,
  data: DEFAULT_REMOTE_CONFIG_PARAMETERS,
};

export const remoteConfigSlice = createSlice({
  name: "remoteConfig",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchRemoteConfigThunk.pending,
      (state: TRemoteConfigState) => {
        state.loading = true;
      }
    );
    builder.addCase(
      fetchRemoteConfigThunk.rejected,
      (state: TRemoteConfigState) => {
        state.loading = false;
      }
    );
    builder.addCase(
      fetchRemoteConfigThunk.fulfilled,
      (state: TRemoteConfigState, { payload }) => {
        state.loading = false;
        state.neverLoaded = false;
        state.data = payload;
      }
    );
  },
});

export default remoteConfigSlice.reducer;
